import React from 'react';
import { FaTwitter, FaTelegram, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="icons-container">
          <a href="https://twitter.com/AIrea_51_
          " target="_blank" rel="noopener noreferrer">
            <FaTwitter className="icon" />
          </a>
          <a href="https://t.me/airea51" target="_blank" rel="noopener noreferrer">
            <FaTelegram className="icon" />
          </a>
          <a href="mailto:contactus@airea51.xyz">
            <FaEnvelope className="icon" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
